import { request, localConfig, combineUrl } from '~/common';

const docRequest = (params, callback, action) => {
    return request(combineUrl(localConfig.obtApiUrl, `Document/V1/json/${action}`), params, callback);
}

export function SearchVoucher(params, callback) {
    return docRequest(params, callback, 'SearchVoucher');
}

export function RequestDownloadVoucher(params, callback) {
    return docRequest(params, callback, 'RequestDownloadVoucher');
}

export function SearchDownloadVoucher(params, callback) {
    return docRequest(params, callback, 'SearchDownloadVoucher');
}

export function ApplyVouchers(params, callback) {
    return docRequest(params, callback, 'ApplyVouchers');
}

const docFileRequest = (params, callback, action) => {
    return request(combineUrl(localConfig.obtApiUrl, `Document/V1/json/${action}`), params, callback, { file: true });
}

export function DownloadVoucher(params, callback) {
    return docFileRequest(params, callback, 'DownloadVoucher');
}

export function DownloadVouchersZip(params, callback) {
    return docFileRequest(params, callback, 'DownloadVouchersZip');
}
